export enum STORAGE_KEYS {
    USER_DATA = 'user-data',
    TOKEN = 'token',
    REFRESH_TOKEN = 'refresh_token',
    API_KEY = 'api-key',
    WALLET_VIEW_MODE = 'wallets_view_mode'
}